// The Planet Vertexia (Animation) System
// all geo, materials, and positioning handled here
// orbit paths too?
import * as THREE from "three"
import Experience from "../Experience"

//import OrbitPath from "./OrbitPath.js"

import CustomShaderMaterial from "three-custom-shader-material/vanilla"
import planetPhotographyVertexShader from "../../shaders/planetPhotography/planetPhotographyVertex.glsl"
import planetPhotographyFragmentShader from "../../shaders/planetPhotography/planetPhotographyFragment.glsl"

import moonAnimationModelingVertexShader from "../../shaders/moonAnimationModeling/moonAnimationModelingVertex.glsl"
import moonAnimationModelingFragmentShader from "../../shaders/moonAnimationModeling/moonAnimationModelingFragment.glsl"

//import moonAnimationRiggingVertexShader from "../../shaders/moonAnimationRigging/moonAnimationRiggingVertex.glsl"
//import moonAnimationRiggingFragmentShader from "../../shaders/moonAnimationRigging/moonAnimationRiggingFragment.glsl"

import { mergeVertices } from "three/examples/jsm/utils/BufferGeometryUtils.js"


// Planet Photography
export class PlanetPhotography{
    constructor(){
        this.experience = new Experience()
        this.time = this.experience.time
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.orbitPathFile = this.resources.items.orbitModel
        this.orbitPath = this.orbitPathFile.children[0]
        this.orbits = []
        this.planetGroup = new THREE.Group()
        this.planetAngle = -23.5
        this.planetTilt = this.planetAngle * (Math.PI / 180)
        this.orbitDistance = 65
        this.orbitSpeed = 0.0
        this.offsetRadians = 1.15
        

        this.moonAOrbitDistance = 9
        this.moonBOrbitDistance = 11
        this.moonCOrbitDistance = 15
        this.moonDOrbitDistance = 19
        
        // Subscribe to the tick function
        this.time.addEventListener("tick", ()=>{
            this.rotate()
            this.orbit()
        })

        this.setGeometry()
        this.setTextures()
        this.setMaterials()
        this.setMesh()
        this.setPosition()
        this.setOrbitPaths()
    }

    setGeometry(){
        let photographyPlanetGeo = new THREE.IcosahedronGeometry(5, 40)
        this.geometry = mergeVertices(photographyPlanetGeo)
        this.geometry.computeTangents()
    }
    setTextures(){
        
    }

    setMaterials(){
        this.lineMat = new THREE.LineBasicMaterial({
            color: 0x555555,
            linewidth:1
        })

        this.colors = {}
        this.colors.colorA = '#c266a7'
        this.colors.colorB = '#52489f'
        this.colors.roughnessLow = '0.1'
        this.colors.roughnessHigh = '0.9'

        this.uniforms = {}
        this.uniforms.uPositionFrequency = new THREE.Uniform(0.4),
        this.uniforms.uStrength = new THREE.Uniform(0.1),
        this.uniforms.uColorLow = new THREE.Uniform(new THREE.Color(this.colors.colorA)),
        this.uniforms.uColorHigh = new THREE.Uniform(new THREE.Color(this.colors.colorB))
        
        this.material = new CustomShaderMaterial({
            // CustomShaderMaterial
            baseMaterial: THREE.MeshPhysicalMaterial,
            //baseMaterial: THREE.MeshStandardMaterial,
            vertexShader: planetPhotographyVertexShader,
            fragmentShader: planetPhotographyFragmentShader,
            uniforms: this.uniforms,
            silent: true,
            
            //MeshPhysicalMaterial
            metalness: 0.0,
            roughness: 0.0,
            color: 0xffffff,
            emissive: 0x000000,
            transmission: 0.0,
            ior: 1.5,
            thickness: 1.5,
            transparent: false,
            wireframe: false,
            depthWrite: true,
            depthTest: true,
        })
    }

    setMesh(){
        this.mesh = new THREE.Mesh(
            this.geometry,
            this.material
        )
        this.mesh.castShadow = true
        this.mesh.receiveShadow = true
        this.mesh.rotation.order = "ZYX"
        //this.mesh.rotation.z = -23.5 * (Math.PI / 180)
        this.mesh.rotation.z = this.planetTilt
        this.scene.add(this.mesh)
    }

    setPosition(){
        // Set the Parent Planet Parameters
        //this.planetTilt = -23.5 * (Math.PI / 180)
        //this.orbitDistance = 65
        //this.orbitSpeed = 0.0
        //this.offset = Math.PI * 1.15
        this.offset = Math.PI * this.offsetRadians
        this.planetGroup.position.x = this.orbitDistance * Math.sin(((this.time.elapsed * 0.001) * this.orbitSpeed) + this.offset)
        this.planetGroup.position.z = this.orbitDistance * Math.cos(((this.time.elapsed * 0.001) * this.orbitSpeed) + this.offset)
        this.scene.add(this.planetGroup)
    }

    setOrbitPaths(){
        this.orbitPath.material = this.lineMat
        // duplicates and places nurbs geo for orbit representation
        let tempPlanetPath
        let tempMoonAPath
        let tempMoonBPath
        let tempMoonCPath
        let tempMoonDPath
        
        for(let i = 0; i < 5; i ++){
            const childClone = this.orbitPath.clone()
            this.scene.add(childClone)
            this.orbits.push(childClone)
        }
        [
            tempPlanetPath,
            tempMoonAPath,
            tempMoonBPath,
            tempMoonCPath,
            tempMoonDPath
        ] = this.orbits

        // Set orbit transforms
        this.planetPath = tempPlanetPath
        this.planetPath.scale.set(this.orbitDistance, this.orbitDistance, this.orbitDistance)

        this.moonAPath = tempMoonAPath
        this.moonAPath.scale.set(this.moonAOrbitDistance, this.moonAOrbitDistance, this.moonAOrbitDistance)
        this.moonAPath.rotation.set(0,0,this.planetTilt)

        this.moonBPath = tempMoonBPath
        this.moonBPath.scale.set(this.moonBOrbitDistance, this.moonBOrbitDistance, this.moonBOrbitDistance)
        this.moonBPath.rotation.set(0,0,this.planetTilt)

        this.moonCPath = tempMoonCPath
        this.moonCPath.scale.set(this.moonCOrbitDistance, this.moonCOrbitDistance, this.moonCOrbitDistance)
        this.moonCPath.rotation.set(0,0,this.planetTilt)

        this.moonDPath = tempMoonDPath
        this.moonDPath.scale.set(this.moonDOrbitDistance, this.moonDOrbitDistance, this.moonDOrbitDistance)
        this.moonDPath.rotation.set(0,0,this.planetTilt)

    }

    rotate(){
        this.mesh.rotation.y = (this.time.elapsed * 0.001) * 0.2
    }

    orbit(){
        if(this.planetGroup){
            this.mesh.position.x = this.planetGroup.position.x
            this.mesh.position.z = this.planetGroup.position.z
        }

        if(this.moonAPath){
            this.moonAPath.position.x = this.planetGroup.position.x
            this.moonAPath.position.z = this.planetGroup.position.z
        }

        if(this.moonBPath){
            this.moonBPath.position.x = this.planetGroup.position.x
            this.moonBPath.position.z = this.planetGroup.position.z
        }

        if(this.moonCPath){
            this.moonCPath.position.x = this.planetGroup.position.x
            this.moonCPath.position.z = this.planetGroup.position.z
        }

        if(this.moonDPath){
            this.moonDPath.position.x = this.planetGroup.position.x
            this.moonDPath.position.z = this.planetGroup.position.z
        }

    }
}

export class MoonPhotographyPets{
    constructor(parentPlanet){
        this.experience = new Experience()
        this.time = this.experience.time
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        this.parentPlanet = parentPlanet
        this.planetGroup = this.parentPlanet.planetGroup
        this.planetTilt = this.parentPlanet.planetTilt
        this.orbitDistance = this.parentPlanet.moonAOrbitDistance
        
        // Subscribe to the tick function
        this.time.addEventListener("tick", ()=>{
            this.rotate()
            this.orbit()
        })

        //console.log("Moon - Photography - Pets")
        this.setGeometry()
        this.setTextures()
        this.setMaterials()
        this.setMesh()
        this.setPosition()
    }

    setGeometry(){
        let moonPhotographyPetsGeo = new THREE.IcosahedronGeometry(.25, 25)
        this.geometry = mergeVertices(moonPhotographyPetsGeo)
        this.geometry.computeTangents()
    }
    setTextures(){
        
    }

    setMaterials(){
        this.colors = {}
        this.colors.colorA = '#04bcff'
        this.colors.colorB = '#eaff04'
        this.colors.roughnessLow = '0.1'
        this.colors.roughnessHigh = '0.9'

        this.uniforms = {}
        this.uniforms.uPositionFrequency = new THREE.Uniform(7.0),
        this.uniforms.uStrength = new THREE.Uniform(0.025),
        this.uniforms.uColorLow = new THREE.Uniform(new THREE.Color(this.colors.colorA)),
        this.uniforms.uColorHigh = new THREE.Uniform(new THREE.Color(this.colors.colorB))
        
        this.material = new CustomShaderMaterial({
            // CustomShaderMaterial
            baseMaterial: THREE.MeshPhysicalMaterial,
            vertexShader: moonAnimationModelingVertexShader,
            fragmentShader: moonAnimationModelingFragmentShader,
            uniforms: this.uniforms,
            silent: true,
            
            //MeshPhysicalMaterial
            metalness: 0.0,
            roughness: 1.0,
            color: 0xffffff,
            emissive: 0x000000,
            transmission: 0.0,
            ior: 1.5,
            thickness: 1.5,
            transparent: false,
            wireframe: false,
            depthWrite: true,
            depthTest: true,
        })
    }

    setMesh(){
        this.mesh = new THREE.Mesh(
            this.geometry,
            this.material
        )
        this.mesh.castShadow = true
        this.mesh.receiveShadow = true
        this.scene.add(this.mesh)
    }
    
    setPosition(){
        this.orbitPlane = (Math.sin(this.planetTilt) * this.orbitDistance) / (Math.tan(this.planetTilt))
        this.orbitSpeed = 0.1
        this.offset = Math.PI * 1.5
    }
    
    rotate(){
        this.mesh.rotation.y = (this.time.elapsed * 0.001) * 0.3
    }

    orbit(){

        if(this.planetGroup){
            this.mesh.position.x = this.planetGroup.position.x + (this.orbitPlane * Math.sin(((this.time.elapsed * 0.001) * this.orbitSpeed) + this.offset))
            this.mesh.position.z = this.planetGroup.position.z + (this.orbitDistance * Math.cos(((this.time.elapsed * 0.001) * this.orbitSpeed) + this.offset))
            this.mesh.position.y = this.planetGroup.position.y + (this.orbitDistance * Math.sin(this.planetTilt) * Math.sin(((this.time.elapsed * 0.001) * this.orbitSpeed) + this.offset))
        }
        else{
            console.log("no Planet Group")
        }
    }
}

export class MoonPhotographyPeople{
    constructor(parentPlanet){
        this.experience = new Experience()
        this.time = this.experience.time
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        this.parentPlanet = parentPlanet
        this.planetGroup = this.parentPlanet.planetGroup
        this.planetTilt = this.parentPlanet.planetTilt
        this.orbitDistance = this.parentPlanet.moonBOrbitDistance
        
        // Subscribe to the tick function
        this.time.addEventListener("tick", ()=>{
            this.rotate()
            this.orbit()
        })

        //console.log("Moon - Photography - People")
        this.setGeometry()
        this.setTextures()
        this.setMaterials()
        this.setMesh()
        this.setPosition()
    }

    setGeometry(){
        let moonAnimationRiggingGeo = new THREE.IcosahedronGeometry(1, 25)
        this.geometry = mergeVertices(moonAnimationRiggingGeo)
        this.geometry.computeTangents()
    }
    setTextures(){
        
    }

    setMaterials(){
        this.colors = {}
        this.colors.colorA = '#720bc6'
        this.colors.colorB = '#056c71'
        this.colors.roughnessLow = '0.1'
        this.colors.roughnessHigh = '0.9'

        this.uniforms = {}
        this.uniforms.uPositionFrequency = new THREE.Uniform(1.0),
        this.uniforms.uStrength = new THREE.Uniform(0.1),
        this.uniforms.uColorLow = new THREE.Uniform(new THREE.Color(this.colors.colorA)),
        this.uniforms.uColorHigh = new THREE.Uniform(new THREE.Color(this.colors.colorB))
        
        this.material = new CustomShaderMaterial({
            // CustomShaderMaterial
            baseMaterial: THREE.MeshPhysicalMaterial,
            vertexShader: moonAnimationModelingVertexShader,
            fragmentShader: moonAnimationModelingFragmentShader,
            uniforms: this.uniforms,
            silent: true,
            
            //MeshPhysicalMaterial
            metalness: 0.0,
            roughness: 1.0,
            color: 0xffffff,
            emissive: 0x000000,
            transmission: 0.0,
            ior: 1.5,
            thickness: 1.5,
            transparent: false,
            wireframe: false,
            depthWrite: true,
            depthTest: true,
        })
    }

    setMesh(){
        this.mesh = new THREE.Mesh(
            this.geometry,
            this.material
        )
        this.mesh.castShadow = true
        this.mesh.receiveShadow = true
        this.scene.add(this.mesh)
    }
    
    setPosition(){
        //should get this from parent planet
        //this.planetTilt = 20 * (Math.PI / 180)
        this.orbitPlane = (Math.sin(this.planetTilt) * this.orbitDistance) / (Math.tan(this.planetTilt))
        this.orbitSpeed = 0.09
        this.offset = Math.PI * 1.25
    }
    
    rotate(){
        this.mesh.rotation.y = (this.time.elapsed * 0.001) * 0.6
    }

    orbit(){

        if(this.planetGroup){
            this.mesh.position.x = this.planetGroup.position.x + (this.orbitPlane * Math.sin(((this.time.elapsed * 0.001) * this.orbitSpeed) + this.offset))
            this.mesh.position.z = this.planetGroup.position.z + (this.orbitDistance * Math.cos(((this.time.elapsed * 0.001) * this.orbitSpeed) + this.offset))
            this.mesh.position.y = this.planetGroup.position.y + (this.orbitDistance * Math.sin(this.planetTilt) * Math.sin(((this.time.elapsed * 0.001) * this.orbitSpeed) + this.offset))
        }
        else{
            console.log("no Planet Group")
        }
    }
}

export class MoonPhotographyProducts{
    constructor(parentPlanet){
        this.experience = new Experience()
        this.time = this.experience.time
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        this.parentPlanet = parentPlanet
        this.planetGroup = this.parentPlanet.planetGroup
        this.planetTilt = this.parentPlanet.planetTilt
        this.orbitDistance = this.parentPlanet.moonCOrbitDistance
        
        // Subscribe to the tick function
        this.time.addEventListener("tick", ()=>{
            this.rotate()
            this.orbit()
        })

        //console.log("Moon - Photography - Products")
        this.setGeometry()
        this.setTextures()
        this.setMaterials()
        this.setMesh()
        this.setPosition()
    }

    setGeometry(){
        let moonAnimationAnimationGeo = new THREE.IcosahedronGeometry(0.75, 25)
        this.geometry = mergeVertices(moonAnimationAnimationGeo)
        this.geometry.computeTangents()
    }
    setTextures(){
        
    }

    setMaterials(){
        this.colors = {}
        this.colors.colorA = '#4fa5d8'
        this.colors.colorB = '#0855b1'
        this.colors.roughnessLow = '0.1'
        this.colors.roughnessHigh = '0.9'

        this.uniforms = {}
        this.uniforms.uPositionFrequency = new THREE.Uniform(3),
        this.uniforms.uStrength = new THREE.Uniform(0.025),
        this.uniforms.uColorLow = new THREE.Uniform(new THREE.Color(this.colors.colorA)),
        this.uniforms.uColorHigh = new THREE.Uniform(new THREE.Color(this.colors.colorB))
        
        this.material = new CustomShaderMaterial({
            // CustomShaderMaterial
            baseMaterial: THREE.MeshPhysicalMaterial,
            vertexShader: moonAnimationModelingVertexShader,
            fragmentShader: moonAnimationModelingFragmentShader,
            uniforms: this.uniforms,
            silent: true,
            
            //MeshPhysicalMaterial
            metalness: 0.0,
            roughness: 1.0,
            color: 0xffffff,
            emissive: 0x000000,
            transmission: 0.0,
            ior: 1.5,
            thickness: 1.5,
            transparent: false,
            wireframe: false,
            depthWrite: true,
            depthTest: true,
        })
    }

    setMesh(){
        this.mesh = new THREE.Mesh(
            this.geometry,
            this.material
        )
        this.mesh.castShadow = true
        this.mesh.receiveShadow = true
        this.scene.add(this.mesh)
    }
    
    setPosition(){
        this.orbitPlane = (Math.sin(this.planetTilt) * this.orbitDistance) / (Math.tan(this.planetTilt))
        this.orbitSpeed = 0.1
        this.offset = Math.PI * 0.6
    }
    
    rotate(){
        this.mesh.rotation.y = (this.time.elapsed * 0.001) * 0.25
    }

    orbit(){

        if(this.planetGroup){
            this.mesh.position.x = this.planetGroup.position.x + (this.orbitPlane * Math.sin(((this.time.elapsed * 0.001) * this.orbitSpeed) + this.offset))
            this.mesh.position.z = this.planetGroup.position.z + (this.orbitDistance * Math.cos(((this.time.elapsed * 0.001) * this.orbitSpeed) + this.offset))
            this.mesh.position.y = this.planetGroup.position.y + (this.orbitDistance * Math.sin(this.planetTilt) * Math.sin(((this.time.elapsed * 0.001) * this.orbitSpeed) + this.offset))
        }
        else{
            console.log("no Planet Group")
        }
    }
}

export class MoonPhotographyMisc{
    constructor(parentPlanet){
        this.experience = new Experience()
        this.time = this.experience.time
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        this.parentPlanet = parentPlanet
        this.planetGroup = this.parentPlanet.planetGroup
        this.planetTilt = this.parentPlanet.planetTilt
        this.orbitDistance = this.parentPlanet.moonDOrbitDistance
        
        // Subscribe to the tick function
        this.time.addEventListener("tick", ()=>{
            this.rotate()
            this.orbit()
        })

        //console.log("Moon - Photography - Misc")
        this.setGeometry()
        this.setTextures()
        this.setMaterials()
        this.setMesh()
        this.setPosition()
    }

    setGeometry(){
        let moonAnimationRiggingGeo = new THREE.IcosahedronGeometry(.35, 25)
        this.geometry = mergeVertices(moonAnimationRiggingGeo)
        this.geometry.computeTangents()
    }
    setTextures(){
        
    }

    setMaterials(){
        this.colors = {}
        this.colors.colorA = '#017fb1'
        this.colors.colorB = '#381707'
        this.colors.roughnessLow = '0.1'
        this.colors.roughnessHigh = '0.9'

        this.uniforms = {}
        this.uniforms.uPositionFrequency = new THREE.Uniform(6.5),
        this.uniforms.uStrength = new THREE.Uniform(0.01),
        this.uniforms.uColorLow = new THREE.Uniform(new THREE.Color(this.colors.colorA)),
        this.uniforms.uColorHigh = new THREE.Uniform(new THREE.Color(this.colors.colorB))
        
        this.material = new CustomShaderMaterial({
            // CustomShaderMaterial
            baseMaterial: THREE.MeshPhysicalMaterial,
            vertexShader: moonAnimationModelingVertexShader,
            fragmentShader: moonAnimationModelingFragmentShader,
            uniforms: this.uniforms,
            silent: true,
            
            //MeshPhysicalMaterial
            metalness: 0.0,
            roughness: 1.0,
            color: 0xffffff,
            emissive: 0x000000,
            transmission: 0.0,
            ior: 1.5,
            thickness: 1.5,
            transparent: false,
            wireframe: false,
            depthWrite: true,
            depthTest: true,
        })
    }

    setMesh(){
        this.mesh = new THREE.Mesh(
            this.geometry,
            this.material
        )
        this.mesh.castShadow = true
        this.mesh.receiveShadow = true
        this.scene.add(this.mesh)
    }
    
    setPosition(){
        this.orbitPlane = (Math.sin(this.planetTilt) * this.orbitDistance) / (Math.tan(this.planetTilt))
        this.orbitSpeed = 0.01
        this.offset = Math.PI * 0.5
    }
    
    rotate(){
        this.mesh.rotation.y = (this.time.elapsed * 0.001) * 0.25
    }

    orbit(){

        if(this.planetGroup){
            this.mesh.position.x = this.planetGroup.position.x + (this.orbitPlane * Math.sin(((this.time.elapsed * 0.001) * this.orbitSpeed) + this.offset))
            this.mesh.position.z = this.planetGroup.position.z + (this.orbitDistance * Math.cos(((this.time.elapsed * 0.001) * this.orbitSpeed) + this.offset))
            this.mesh.position.y = this.planetGroup.position.y + (this.orbitDistance * Math.sin(this.planetTilt) * Math.sin(((this.time.elapsed * 0.001) * this.orbitSpeed) + this.offset))
        }
        else{
            console.log("no Planet Group")
        }
    }
}